import React, { useState } from "react"
import { zeroPad } from "../../lib"
import arrow_right_sm from "../../images/icon/arrow-right-sm.svg"

function ProductImageSelector({ images, sliderRef }) {
  const [index, setIndex] = useState(sliderRef ? sliderRef.selectedIndex : 0)

  function handleSelect(idx) {
    if (sliderRef) {
      sliderRef.select(idx)
      setIndex(idx)
    }
  }

  function handleNext() {
    if (sliderRef) {
      sliderRef.next()
    }
  }

  if (sliderRef) {
    sliderRef.on("change", e => {
      handleSelect(e)
    })
  }

  return (
    <div className="product__image-titles">
      <div>
        {images.map((_image, idx) => {
          const active = idx === index
          return (
            <div key={idx} className={active ? "is-active" : ""}>
              <button onClick={() => handleSelect(idx)} key={idx}>
                <span>{zeroPad(idx + 1)}</span>
              </button>
            </div>
          )
        })}
      </div>
      <button
        className="product__image-titles__next"
        onClick={() => handleNext()}
      >
        <img src={arrow_right_sm} alt="Next" />
      </button>
    </div>
  )
}

export default ProductImageSelector
